<template>
	<div>
		<v-tabs v-model="tabsModel" slider-color="cyan" class="custom-tabs">
			<v-tab v-for="(tab, index) in tabs" :key="index" class="tab-item">
				{{ tab.name }}
			</v-tab>
			<v-tabs-items>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagProducts" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12>
								<v-flex xs12 mb-3>
									<p class="company-text-regular ma-0">Tipo de Producto:</p>
								</v-flex>
								<v-layout row>
									<!-- TODO: Estos elementos deben ser dinamicos, por servicio -->
									<v-flex xs11>
										<v-layout wrap>
											<v-flex xs5>
												<v-checkbox
													color="success"
													v-model="selectTypeProducts"
													label="Producto Terminado"
													:value="codeProduct"></v-checkbox>
											</v-flex>
											<v-flex xs4>
												<v-checkbox
													color="success"
													v-model="selectTypeProducts"
													label="Servicio"
													:value="codeServices"></v-checkbox>
											</v-flex>
											<v-flex xs3>
												<v-checkbox
													color="success"
													v-model="selectTypeProducts"
													label="Compuesto"
													:value="codeComposed"></v-checkbox>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagSales" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagQuotations" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagOrders" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flaDistributions" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs5>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12 mb-3>
								<v-layout row wrap>
									<v-flex xs5>
										<p class="company-text-regular ma-0">
											Forma de calcular distancia - (distanceMode)
										</p>
									</v-flex>
									<v-flex xs1 ml-1>
										<app-tooltip-button
											color="primary"
											icon="help"
											text="Forma en la que se calculará la distancia entre el comercio y la dirección del cliente en el pedido"
										></app-tooltip-button>
									</v-flex>
									<v-flex xs3>
										<v-select
											label=""
											hide-details
											v-model="flagKardex.distanceMode"
											item-text="name"
											item-value="id"
											:items="typeDistanceMode"
										></v-select>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagAccounting" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagAgencyTranport" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagPointSale" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagCustomers" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagPurchases" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 ml-5 mt-4 class="scroll-container">
						<v-layout wrap>
							<v-flex xs12 mb-3 v-for="(flag, index) in flagSupport" :key="index">
								<v-layout row wrap align-center>
									<v-flex xs10>
										<span class="company-text-regular ma-0">
											{{ flag.name }}
										</span>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													:text="flag.tooltip"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-switch
													color="success"
													hide-details
													v-model="flagKardex[flag.flag]"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
							<!-- <v-flex xs12 mb-3>
								<v-layout row wrap>
									<v-flex xs10>
										<p class="company-text-regular ma-0">
											Impuesto por defecto (código) - (codeDefaultTaxes)
										</p>
									</v-flex>
									<v-flex xs2 pl-2>
										<v-layout row align-center>
											<v-flex>
												<app-tooltip-button
													color="primary"
													icon="help"
													text="Impuesto por defecto"
												></app-tooltip-button>
											</v-flex>
											<v-flex>
												<v-text-field
													hide-details
													v-model="flagKardex.codeDefaultTaxes"
												></v-text-field>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex> -->
						</v-layout>
					</v-flex>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>
<script>

import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
    return {
        flagKardex: null,
		selectTypeProducts: [],
		codeComposed: 6,
		codeProduct: 1,
		codeServices: 2,
		tabsModel: null,
		valueTabs: null,
		typeDistanceMode: [
			{
				id: 1,
				name: 'Lineal',
			},
			{
				id: 2,
				name: 'Vehicular',
			},
		],
		tabs: [
			{
				id: 1,
				name: 'Productos',
			},
			{
				id: 2,
				name: 'Ventas',
			},
			{
				id: 3,
				name: 'Cotización',
			},
			{
				id: 4,
				name: 'Pedidos',
			},
			{
				id: 5,
				name: 'Distribuidor',
			},
			{
				id: 6,
				name: 'Contabilidad',
			},
			{
				id: 7,
				name: 'Agencia de transporte'
			},
			{
				id: 8,
				name: 'Punto de venta'
			},
			{
				id: 9,
				name: 'Cliente'
			},
			{
				id: 10,
				name: 'Compra'
			},
			{
				id: 11,
				name: 'Soporte'
			}
		],
		flagProducts: [
			{
				id: 1,
				name: 'Editar código de un producto - (flagCodeProductAuto)',
				tooltip: 'Al activar este switch, se podrá editar el código del proyecto.',
				flag: 'flagCodeProductAuto',
			},
			{
				id: 2,
				name: 'Permitir Stock Negativo - (stockNegative)',
				tooltip: 'Cuando realiza ventas que no son inmediatas la empresa puede activar esta opción.',
				flag: 'stockNegative',
			},
			{
				id: 3,
				name: 'Descuento global - (globalDiscount)',
				tooltip: 'Si se activa se podrá hacer un descuento  a todos los productos al realizar una venta.',
				flag: 'globalDiscount',
			},
			{
				id: 4,
				name: 'Activar precios por categoría (Android) - (flagCategoryPrice)',
				tooltip: 'Actívalo en caso quieras cambiar el precio del producto por el de categoría.',
				flag: 'flagCategoryPrice',
			},
			{
				id: 5,
				name: 'Mostrar otros códigos - (flagCodes)',
				tooltip: 'Activar esta opción para tenerla opción de agregar varios códigos a tus productos.',
				flag: 'flagCodes'
			},
			{
				id: 6,
				name: 'Mostrar conversiones al crear un producto - (flagConvers)',
				tooltip: 'Activar esta opción cuando se tiene varias presentaciones del producto.',
				flag: 'flagConvers'
			},
			{
				id: 7,
				name: 'Mostrar tipo de producto variaciones al crear un producto - (flagShowVariations)',
				tooltip: 'Activar esta opción cuando tienes un producto padre y  productos hijos.',
				flag: 'flagShowVariations'
			},
			{
				id: 8,
				name: 'Especificar busqueda lineal o generales el listado de productos - (flagTypeSearch)',
				tooltip: 'Activar esta opción se realizara una busqueda general de lo contraria seria una busqueda especifica.',
				flag: 'flagTypeSearch'
			},
			{
				id: 9,
				name: 'Trabajar con Control de Lotes y Fecha de Venc. - (flagWorkWithBatches)',
				tooltip: 'Activar esta opción se realizara trabajar con lotes.',
				flag: 'flagWorkWithBatches'
			},
			{
				id: 10,
				name: 'Desea trabajar con IOT - (flagShowIot)',
				tooltip: 'Activar esta opción la compañia trabajara con IOT.',
				flag: 'flagShowIot'
			},
			{
				id: 11,
				name: 'Configurar tipo de marca simple - (flagUseSimpleBrand)',
				tooltip: 'Activar esta opción se trabajara con un tipo de marca simple.',
				flag: 'flagUseSimpleBrand'
			},
			{
				id: 12,
				name: 'Utilizar el impuesto general del 10% - (flagTaxesIgvTemporary)',
				tooltip: 'Activar esta opción se trabajara con impuesto de 10%.',
				flag: 'flagTaxesIgvTemporary'
			},
			{
				id: 13,
				name: 'Permitir generar código automático - (flagCodeAutoGenerate)',
				tooltip: 'Al activar este switch, se podrá generar un código automático al producto.',
				flag: 'flagCodeAutoGenerate'
			},
			{
				id: 14,
				name: 'Mostrar solo productos con stock en el POS - (flagHideOutOfStockInPOS)',
				tooltip: 'Al activar esta opción, solo se mostrara los productos con stock en el POS.',
				flag: 'flagHideOutOfStockInPOS'
			},
			{
				id: 15,
				name: 'Usar cálculo automático del precio de venta en base al costo - (flagCalculateEarnings)',
				tooltip: 'Si se activa usará el cálculo automático del precio de venta en base al costo mas su ganancia.',
				flag: 'flagCalculateEarnings'
			},
			{
				id: 16,
				name: 'Deshabilitar el boton calcular la cantidad en funcion al precio - (priceToQuantityCalculation)',
				tooltip: 'Activar esta opción deshabilitara el boton calcular la cantidad en funcion al precio en el POS',
				flag: 'priceToQuantityCalculation'
			},
			{
				id: 17,
				name: 'Sincronizar productos sin stock - (flagProductOnlyStock)',
				tooltip: 'Activar esta opción permitira sincronizar sus productos sin stock',
				flag: 'flagProductOnlyStock'
			},
			{
				id: 18,
				name: 'Mostrar opción Inventario Rápido - (flagInventoryFast)',
				tooltip: 'Activar esta opción permitira realizar un inventario rapido',
				flag: 'flagInventoryFast'
			},
			{
				id: 19,
				name: 'Trabajar con Producto Express - (flagProductExpressFlow)',
				tooltip: 'Mostrar seleccion y crear un producto rapido (Parecido a un servicio de producto servicio).',
				flag: 'flagProductExpressFlow'
			},
			{
				id: 20,
				name: 'Permitir Control de Conversiones - (flagStockByConversion)',
				tooltip: 'Activar esta opción permitira tener referencia de stock por Conversiones',
				flag: 'flagStockByConversion'
			}
		],
		flagSales: [
			{
				id: 1,
				name: 'Habilitar Cliente Genérico - (flagGenericSalesCustomer)',
				tooltip: 'Al deshabilitar este campo, no podrá realizar un documento de venta con un cliente genérico.',
				flag: 'flagGenericSalesCustomer'
			},
			{
				id: 2,
				name: '',
				tooltip: 'Activar para descargar las ventas en pdf o desactivar para visualizar el reporte y poder imprimirlo.',
				flag: 'downloadSale',
			},
			{
				id: 3,
				name: 'Mostrar Opción Recargo al Consumo - (flagTip)',
				tooltip: 'Solo se usa para propinas.',
				flag: 'flagTip',
			},
			{
				id: 4,
				name: 'Precio base para cálculo al genera ventas - (flagBasePriceDefault)',
				tooltip: 'Siempre mantener activado.',
				flag: 'flagBasePriceDefault',
			},
			{
				id: 5,
				name: 'Total en efectivo por defecto al crear la venta - (showCash)',
				tooltip: 'Si tu cliente usualmente paga en efectivo te aparecerá por defecto seleccionada la opción de efectivo al momento de realizar una venta.',
				flag: 'showCash',
			},
			{
				id: 6,
				name: 'Descuento por producto al realizar una venta - (singleDiscount)',
				tooltip: 'Permitir realizar un descuento por producto, al realizar una venta.',
				flag: 'singleDiscount',
			},
			{
				id: 7,
				name: 'Mostrar Opción Despachar Productos - (flagTransferDisplay)',
				tooltip: 'Al hablitar este campo, se podra descontar stock al convertir un documento de venta.',
				flag: 'flagTransferDisplay',
			},
			{
				id: 8,
				name: 'Autodespacho - (autoDispatch)',
				tooltip: 'Al hablitar este parametro, se habilitara el autodespacho al realizar una venta.',
				flag: 'autoDispatch',
			},
			{
				id: 9,
				name: '',
				tooltip: 'Al activar esta opción se realizara descuento en monto, de lo contrario se realizara por porcentaje.',
				flag: 'flagTypeDiscount',
			},
			{
				id: 10,
				name: 'Notificar cuando el Precio Venta es menor al Precio Costo - (showNotifySale)',
				tooltip: 'Al activar esta opción se mostrar un mensaje de alerta cuando el precio de venta es mayor al precio de costo.',
				flag: 'showNotifySale',
			},
			{
				id: 11,
				name: 'Mostrar imagen en buscar producto - (showImageSearch)',
				tooltip: 'Al activar esta opción se mostrar un mensaje de alerta cuando el precio de costo es mayor al precio de venta.',
				flag: 'showImageSearch',
			},
			{
				id: 12,
				name: 'Deshabilitar impresión de ticket en el detalle de venta ( Movil ) - (flagDisablePrintMobile)',
				tooltip: 'Al activar esta opción se deshabilitar impresion de ticket en el detalle de venta movil.',
				flag: 'flagDisablePrintMobile',
			},
			{
				id: 13,
				name: 'Habilitar Guia de Remisión Electronica - (flagElectronicGuide)',
				tooltip: 'Al activar esta opción se visualizará las imagenes del producto en la opcion buscar producto.',
				flag: 'flagElectronicGuide',
			},
			{
				id: 14,
				name: 'Editar precios durante la venta - (flagUpdatePrice)',
				tooltip: 'Si tienes un punto de venta y desean que sus vendedores editen el precio activar la opción.',
				flag: 'flagUpdatePrice'
			},
			{
				id: 15,
				name: 'Usar Lector de barras en ventas - (flagBarcodeReader)',
				tooltip: 'Solo activar esta opción siempre y cuando vendas con código de barra.',
				flag: 'flagBarcodeReader'
			},
			{
				id: 16,
				name: 'Asignar empleado a la venta (Android) - (assignEmployee)',
				tooltip: 'Cuando se tenga una sola caja y varios vendedores.',
				flag: 'assignEmployee'
			},
			{
				id: 17,
				name: 'Activar Loyalty - (flagLoyalti)',
				tooltip: 'Permitir al realizar un documento de venta, tus clientes cajeen sus puntos.',
				flag: 'flagLoyalti'
			},
			{
				id: 18,
				name: 'Activar cambio de precio en móvil con clave de supervisor - (flagEditPriceBySupervisor)',
				tooltip: 'Al activar esta opción se activará el cambio de precio en móvil con la clave del supervisor',
				flag: 'flagEditPriceBySupervisor'
			},
			{
				id: 19,
				name: 'Activar anticipos de venta - (flagAdvanceOnSale)',
				tooltip: 'Al activar esta opción se activará los anticipos en ventas.',
				flag: 'flagAdvanceOnSale'
			},
			{
				id: 20,
				name: 'Habilitar la configuración de liquidación por producto en ventas - (flagSettlement)',
				tooltip: 'Al activar esta opción se activará la configuracion de liqudacion por producto en ventas.',
				flag: 'flagSettlement'
			}
		],
		flagQuotations: [
			{
				id: 1,
				name: 'Mostrar Campos de Importación - (flagImport)',
				tooltip: 'Si en caso se trabaje con cotizaciones y  deseas que los días de demora en importar el producto aparezca en la cotización activar esta opción%.',
				flag: 'flagImport'
			},
			{
				id: 2,
				name: 'Configuración para template - (flagQuotation)',
				tooltip: 'Activar esta opción para personalizar tu cotización (Costo Adicional).',
				flag: 'flagQuotation'
			},
			{
				id: 3,
				name: 'Reservar stock - (COTMoveKardex)',
				tooltip: 'Activar esta opción si desea activar reservar stock del producto.',
				flag: 'COTMoveKardex'
			},
			{
				id: 4,
				name: '',
				tooltip: 'Al activar esta opción solamente se podrá convertir a venta una vez y bloqueara el botón de convertir a venta.',
				flag: 'flagMultipleSalesConversionsQuote'
			},
			{
				id: 5,
				name: 'Incluye IGV en cotizaciones - (flagIgv)',
				tooltip: 'El precio de tu productos se va a reflejar si va incluir IGV o no en la cotización.',
				flag: 'flagIgv'
			}
		],
		flagOrders: [
			{
				id: 1,
				name: 'Verificar que se muestre el tipo de origen del pedido - (flagTypeOriginOrder)',
				tooltip: 'Este acción te permite la selección de tipo de origenes al pedido.',
				flag: 'flagTypeOriginOrder'
			},
			{
				id: 2,
				name: 'Ocultar Unidad funcional si esque existe conversión - (flagShowBaseUnit)',
				tooltip: 'Este acción te permite ocutar la unidad de conversión.',
				flag: 'flagShowBaseUnit'
			},
			{
				id: 3,
				name: 'Usar categorías ecommerce recursivas (categorías padres) - (flagCatEcomFather)',
				tooltip: 'En caso utilicen la tienda Virtual activar esta opción.',
				flag: 'flagCatEcomFather'
			},
			{
				id: 4,
				name: 'Mostrar campo slug en producto ecommerce - (flagShowSlugProduct)',
				tooltip: 'Si utilizan a tienda virtual activar esta opción.',
				flag: 'flagShowSlugProduct'
			},
			{
				id: 5,
				name: 'Dirección no requerida para Vendor. - (flagAddressNotRequired)',
				tooltip: 'Esta opción permite elegir si desea la dirección sea requerida o no.',
				flag: 'flagAddressNotRequired'
			},
			{
				id: 6,
				name: 'Compañia Fujo Restaurant - (restaurantFlow)',
				tooltip: 'Esta opcion solo usan las compañias que son restaurants.',
				flag: 'restaurantFlow'
			},
			{
				id: 7,
				name: 'Permitir crear pedido como borrador desde Vendor - (flagEditOrderVendor)',
				tooltip: 'Esta opción permite elegir si desea la dirección sea requerida o no.',
				flag: 'flagEditOrderVendor'
			},
			{
				id: 8,
				name: 'Generación de documentos no sea automática desde integraciones (SHOPIFY) - (flagNotConvertToSaleFlow)',
				tooltip: 'Esta opción permite generar docoumentos no sean automaticas en shopify.',
				flag: 'flagNotConvertToSaleFlow'
			},
			{
				id: 9,
				name: 'Permitir Crear Rutas con pedidos solicitados - (flagEnableRequestedRoutes)',
				tooltip: 'Esta opción permite crear ruta con pedidos solicitados.',
				flag: 'flagEnableRequestedRoutes'
			},
			{
				id: 10,
				name: 'Permitir Crear Rutas con pedidos pendientes - (flagEnablePendingRoutes)',
				tooltip: 'Esta opción permite crear ruta con pedidos pendientes.',
				flag: 'flagEnablePendingRoutes'
			},
			{
				id: 11,
				name: 'Agregar impuesto por defecto (IGV) - (MOVIL) - (flagTypeOriginOrder)',
				tooltip: 'Indica si se debe mostrar o no el selector de impuestos en pantallas de productos.',
				flag: 'flagTypeOriginOrder'
			},
			{
				id: 12,
				name: 'Mostrar solo los productos con stock en la tienda online - (flagHideOutOfStock)',
				tooltip: 'Al activar esta opcion se mostrara solo los productos con stock en la tienda online.',
				flag: 'flagHideOutOfStock'
			},
			{
				id: 13,
				name: 'Mostrar total de pedidos en el listado desde el Móvil - (flagShowTotalOrders)',
				tooltip: 'Activar esta opción para mostrar el total de pedidos en el listado.',
				flag: 'flagShowTotalOrders'
			},
			{
				id: 14,
				name: 'Activar aprobación del administrador para que el vendedor cambie la lista de precio - (flagPriceListChangeApproval)',
				tooltip: 'Este acción te permite usar la aprobación del administrador para que el vendedor cambie la lista de precio',
				flag: 'flagPriceListChangeApproval'
			},
			{
				id: 15,
				name: 'Permitir ingresar el código del vendedor para verificar existencia - (checkSellerWritedCode)',
				tooltip: 'Permitir ingresar el código del vendedor para verificar su existencia; de lo contrario, mostrar un selector de empleados',
				flag: 'checkSellerWritedCode'
			},
			{
				id: 16,
				name: 'Tipo de Conversión a venta - (flagTypeConvertToSale)',
				tooltip: 'Al habilitar esta opción los documentos convertidos a ventas seran automático separado por almacén, sino seria una conversión normal (servicio de venta)',
				flag: 'flagTypeConvertToSale'
			},
			{
				id: 17,
				name: 'Permitir stock Negativo en Pedidos - (allowOrderStockNegative)',
				tooltip: 'Esta opción permitir stock negativo en pedidos',
				flag: 'allowOrderStockNegative'
			},
			{
				id: 18,
				name: 'Permitir editar cliente por rol almacenero - (allowEditCustomerWarehouse)',
				tooltip: 'Esta opción permite editar cliente por rol almacenero',
				flag: 'allowEditCustomerWarehouse'
			},
			{
				id: 19,
				name: 'Activar notificaciones al almacenero al confirmar pedido - (flagNotifyStorekeeper)',
				tooltip: 'Esta opción permite notificar al almacenero al confirmar el pedido',
				flag: 'flagNotifyStorekeeper'
			},
			{
				id: 20,
				name: 'Esta opción permite no imprimir el pedido - (flagDoNotPrintRequestedOrder)',
				tooltip: 'Esta opción permite no imprimir el pedido',
				flag: 'flagDoNotPrintRequestedOrder'
			},
			{
				id: 21,
				name: 'Agregar impuesto por defecto (IGV) - (MOVIL) - (flagTaxesDefault)',
				tooltip: 'Indica si se debe mostrar o no el selector de impuestos en pantallas de productos',
				flag: 'flagTaxesDefault'
			},
			{
				id: 22,
				name: 'Solo despachar si el pedido esta convertido a venta - (flagDispatchConvertedOrder)',
				tooltip: 'Permite despachar pedidos convertidos a venta',
				flag: 'flagDispatchConvertedOrder'
			},
			{
				id: 23,
				name: 'Permitir asignar empleado al crear pedido - (flagAssignEmployeeOrder)',
				tooltip: 'Esta opción permite asignar empleado al crear pedido',
				flag: 'flagAssignEmployeeOrder'
			},
			{
				id: 24,
				name: 'Marcar pedido como confirmado al crear un pedido - (flagDeliveryAsConfirmed)',
				tooltip: 'Esta opción permite marcar como confirmado automáticamente un pedido luego de crearlo',
				flag: 'flagDeliveryAsConfirmed'
			}
		],
		flaDistributions: [
			{
				id: 1,
				name: 'Compañía tipo distribuidor - (flagGrouper)',
				tooltip: 'Se podrá activar esta opción solo cuando son compañías tipo distribuidor y se encuentran dentro del plan Mega',
				flag: 'flagGrouper'
			},
			{
				id: 2,
				name: 'Cierre automatico de rutas - (flagAutomaticRoutesClose)',
				tooltip: 'Finalizar las rutas de forma masiva.',
				flag: 'flagAutomaticRoutesClose'
			}
		],
		flagAccounting: [
			{
				id: 1,
				name: 'Tipo de Integración General - (flagTypeIntegrationGrouper)',
				tooltip: 'Activar en caso se quiera participar en el plan Beta del Modo de contabilidad que se esta lanzando en modo prueba',
				flag: 'flagTypeIntegrationGrouper'
			},
			{
				id: 2,
				name: 'Contabilidad - (flagShowAccountingEngine)',
				tooltip: 'Activar en caso se quiera participar en el plan Beta del Modo de contabilidad que se esta lanzando en modo prueba.',
				flag: 'flagShowAccountingEngine'
			}
		],
		flagAgencyTranport: [
			{
				id: 1,
				name: 'Trabajar con Agencia de transportes - (flagUseTransportAgency)',
				tooltip: 'Permitir enviar tu pedido mediante un agencia de transporte',
				flag: 'flagUseTransportAgency'
			},
			{
				id: 2,
				name: 'Pedir Ubigeo en nueva dirección (App de Pedidos) - (flagRequestLocationOrderApp)',
				tooltip: 'Permitir una dirección exacta al realizar un pedido.',
				flag: 'flagRequestLocationOrderApp'
			},
			{
				id: 3,
				name: 'Pedir Ubigeo en nueva dirección (App de Vendedor de Campo) - (flagAskLocationSellerApp)',
				tooltip: 'Permitir una dirección exacta al realizar un pedido.',
				flag: 'flagAskLocationSellerApp'
			},
			{
				id: 4,
				name: 'Registrar vehículos y conductores del transportista - (flagRelateVehicleFloat)',
				tooltip: 'Indicador para registrar vehículos y conductores del transportista',
				flag: 'flagRelateVehicleFloat'
			}
		],
		flagPointSale: [
			{
				id: 1,
				name: 'Alertar en el punto de venta móvil que un producto posee conversiones - (flagAlertConversions)',
				tooltip: 'Permitir una dirección exacta al realizar un pedido',
				flag: 'flagAlertConversions',
			}
		],
		flagCustomers: [
			{
				id: 1,
				name: 'Habilitar email obligatorio al crear cliente - (emailCustomerMandatory)',
				tooltip: 'Al crear un cliente en configuración si en caso quieras registrar a todos tus clientes con correo activa esta opción.',
				flag: 'emailCustomerMandatory'
			},
			{
				id: 2,
				name: 'Usar el servicio de consulta de Numero de documento - (flagUseDocConsulting)',
				tooltip: 'Si esta activo, usara el servicio de consulta de Documento(Cliente y Proveedor).',
				flag: 'flagUseDocConsulting'
			},
			{
				id: 3,
				name: 'Permitir que se muestren solo clientes asignados a una determinada ruta - (flagShowCustomersAssignedToRoute)',
				tooltip: 'Si esta activo, solo se mostraran clientes asignados a una determinada ruta.',
				flag: 'flagShowCustomersAssignedToRoute'
			}
		],
		flagPurchases: [
			{
				id: 1,
				name: 'Trabajar con Percepción - (flagPerception)',
				tooltip: 'Al activar esta opción, muestra configuración de proveedores con percepcion',
				flag: 'flagPerception'
			},
			{
				id: 2,
				name: 'Limitar conversion de ordenes de compra a cantidad relacionada - (flagNotLimitInORC)',
				tooltip: 'Al activar esta opción, se limitara la conversion de ordenes de compra a cantidad relacionada',
				flag: 'flagNotLimitInORC'
			}
		],
		flagSupport: [
			{
				id: 1,
				name: 'Esta compañía sera de prueba - (flagTest)',
				tooltip: 'si esta actvo, significa que la cuenta es de prueba',
				flag: 'flagTest'
			},
			{
				id: 2,
				name: 'Habilitar el flujo de eliminación de compañía - (flagCompanyEliminated)',
				tooltip: 'Se usaran compañías que pasarán por un flujo de eliminación',
				flag: 'flagCompanyEliminated'
			},
			{
				id: 3,
				name: 'Habilita el registro de asistencia desde móvil - (flagAttendanceRegistration)',
				tooltip: 'Habilitar registro de asistencia desde móvil y controlar consumo de servicios asociados',
				flag: 'flagAttendanceRegistration'
			},
			{
				id: 4,
				name: 'Activar cuenta del acl - (flagEditBlockedAcl)',
				tooltip: 'Al habilitar esta opcion, permite activar la cuenta del ACL',
				flag: 'flagEditBlockedAcl'
			},
			{
				id: 5,
				name: 'Ejecuta cron de actualizacion de Deudas de Clientes - (balanceCustomerAll)',
				tooltip: 'Al habilitar esta opcion, se ejecutara cron de actualizacion de Deudas de Clientes',
				flag: 'balanceCustomerAll'
			},
			{
				id: 6,
				name: 'Ocultar campos del ubigeo de las tiendas - (flagNotUseGlobalUbigeo)',
				tooltip: 'Ocultar campos del ubigeo de las tiendas, menos el campo direccion',
				flag: 'flagNotUseGlobalUbigeo'
			},
			{
				id: 7,
				name: 'Generar documentos de venta al contado - (flagSalDocAsCash)',
				tooltip: 'Al activar esta opción, los documentos de venta se crearan con metodo de pago al contado',
				flag: 'flagSalDocAsCash'
			},
			{
				id: 8,
				name: 'Limitaciones en la Firma Móvil para Cobros y Pagos - (flagDisabledSignature)',
				tooltip: 'Al activar esta opción, no permitira agregar firma en movil al momento de hacer cobros/pagos',
				flag: 'flagDisabledSignature'
			},
			{
				id: 9,
				name: 'Generar y Guardar Ticket en PDF - (flagDownloadOrder)',
				tooltip: 'Permite generar y guardar el pdf un ticket de pdf',
				flag: 'flagDownloadOrder'
			},
			{
				id: 10,
				name: 'Permitir editar el código externo de una venta en el listado - (flagExternalData)',
				tooltip: 'Permitir editar el código externo de una venta en el listado',
				flag: 'flagExternalData'
			},
			{
				id: 11,
				name: 'Indica que se verifica stock negativo de productos agrupados en backend - (flagStockProductGroup)',
				tooltip: 'Al activar esta opción verifica stock negativo de productos agrupados en backend',
				flag: 'flagStockProductGroup'
			},
			{
				id: 12,
				name: 'Permite realizar intercambio de puntos por producto - (flagExchangePointsByProduct)',
				tooltip: 'Al activar esta opción se podra intercambiar puntos por producto',
				flag: 'flagExchangePointsByProduct'
			},
			{
				id: 13,
				name: 'Permitir muestra lista de sincronizacion de productos maestros - (wholesaler)',
				tooltip: 'Al activar esta opción permitir mostrar lista de sincronización de productos maestros',
				flag: 'wholesaler'
			},
			{
				id: 14,
				name: 'Trabajar con Producto Fabricado - (flagFlowManufacturedProduct)',
				tooltip: 'Permitir Mostrar tipo de producto Insumo y crer tipo manufacturado como terminado.',
				flag: 'flagFlowManufacturedProduct'
			},
			{
				id: 15,
				name: 'Permitir registros para sincronización de stock de productos - (flagSyncMoveTypeFirebase)',
				tooltip: 'Permitir registros para sincronización de stock de productos',
				flag: 'flagSyncMoveTypeFirebase'
			},
			{
				id: 16,
				name: 'Indicar si la empresa trabajara con conversion (intercambio de documento NTV -> BOL) - (flagChangeNtvFlow)',
				tooltip: 'Permitir intercambiar numeracion al convertir notas de venta(relacionadas a pedidos) a boleta/factura.',
				flag: 'flagChangeNtvFlow'
			},
			{
				id: 17,
				name: 'Configuracion temporal para trabajar con la nueva estructura de kardex - (flagNewKardexV3)',
				tooltip: 'Configuracion temporal para pruebas que trabjan con la nueva estructura de kardex',
				flag: 'flagNewKardexV3'
			},
			{
				id: 18,
				name: 'Indica ingreso directo a tablas de productos maestro/almacen - (flagNotMoveKardex)',
				tooltip: 'Indica ingreso directo a tablas de productos maestro/almacen. En caso este desactivado se manejará el registro de stock en Kardex',
				flag: 'flagNotMoveKardex'
			},
			{
				id: 19,
				name: 'Utilizar costo promedio / Utilizar último costo (Dinámico) - (flagKardexValued)',
				tooltip: 'Si activo esta opción se usará el calculo de costo promedio si en caso lo desactivo el costo que se va a mostrar en tu producto maestro va hacer el último costo de tu compra.',
				flag: 'flagKardexValued'
			},
			{
				id: 20,
				name: 'Calculo de saldo de stock y costo inmediato - (flagKardexFast)',
				tooltip: 'Indica si el inmediatamente despues de registrar en el kardex estos registros se les calculará el stock y/o costo',
				flag: 'flagKardexFast'
			},
			{
				id: 21,
				name: 'Registro inmediato por DB / Registro por SQS (Dinámico) - (typeRegisterKardex)',
				tooltip: 'Al habilitar este campo se genera un registro inmediato por DB, de lo contrario se registra por SQS',
				flag: 'typeRegisterKardex'
			},
			{
				id: 22,
				name: 'Permitir realizar solicitudes aprobadas por defecto y recepcionar transferencias - (flagImmediateTransfer)',
				tooltip: 'Permitir realizar solicitudes aprobadas por defecto y recepcionar transferencias no aceptados por el un administrador',
				flag: 'flagImmediateTransfer'
			},
			{
				id: 23,
				name: 'Incluir código de impuesto por defecto - (codeDefaultTaxes)',
				tooltip: 'Incluir código de impuesto por defecto',
				flag: 'codeDefaultTaxes'
			},
			{
				id: 24,
				name: 'Permite visualizar el historial de cambios del precio los productos en el punto de venta - (flagAuditService)',
				tooltip: 'Permite visualizar el historial de cambios del precio los productos en el punto de venta',
				flag: 'flagAuditService'
			},
			{
				id: 25,
				name: 'Habilitar redondeo de ventas - (flagRoundSales)',
				tooltip: 'Habilitar redondeo de ventas.',
				flag: 'flagRoundSales'
			},
			{
				id: 26,
				name: 'Indicar si las compras tendran ingreso a caja - (flagPurCashDeskClosing)',
				tooltip: 'Indicar si las compras tendran ingreso a caja',
				flag: 'flagPurCashDeskClosing'
			},
			{
				id: 27,
				name: 'Autogenerar Series de Compras - (flagPurAutoGenerateSerie)',
				tooltip: 'Indicar que los tipos de documentos de compra con flagGenerateSerie crearan serie por defecto.',
				flag: 'flagPurAutoGenerateSerie'
			},
			{
				id: 28,
				name: 'Notificacion por topic a movil al convertir pedido a venta - (flagNotifySalesConversion)',
				tooltip: 'Envia notificacion por topic a movil al convertir pedido a venta.',
				flag: 'flagNotifySalesConversion'
			},
			{
				id: 29,
				name: 'Habilitar recurso de anexo de caja (POS) - (flagAnnexTransactions)',
				tooltip: 'Habilitar recurso de anexo de caja (POS)',
				flag: 'flagAnnexTransactions'
			}
		]
    };
}

function created() {
	const settings = this.data.items.data.settings;
    this.flagKardex = settings;
	this.selectTypeProducts = settings.typeProductsCreationPermission || [];
	this.flagSales[1].name = settings.downloadSale ? 'Descargar Documento' : 'Vista Previa del Documento';
	this.flagSales[8].name = settings.flagTypeDiscount ? 'Descuento por monto - (flagTypeDiscount)' : 'Descuento por porcentaje - (flagTypeDiscount)';
	this.flagQuotations[3].name = settings.flagMultipleSalesConversionsQuote
		? 'Permitir realizar solamente una conversión a venta - (flagMultipleSalesConversionsQuote)'
		: 'Permitir realizar multiples conversiones a venta - (flagMultipleSalesConversionsQuote)';
}

export default {
    name: 'configuration-params-globales',
    data,
    components: {
        appTooltipButton
    },
    created,
    computed: {
        labelShowKardex() {
            return this.flagKardex.flagKardexValued ? 'Utilizar costo promedio' :
                'Utilizar último costo';
        },
        labelShowRegisterKardex() {
            return this.typeRegisterKardex ? 'Registro inmediato por DB' : 'Registro por SQS';
        },
    },
    props: {
        data: {
            type: Object,
        },
    },
    watch: {
		tabsModel(value) {
			this.valueTabs = value;
		},
        flagKardex: {
            handler(newVal) {
                this.$emit('update:flagKardex', newVal, 'paramsGlobal');
            },
            deep: true
        }
    },
};

</script>
<style scoped>
.scroll-container {
    max-height: 60vh;
    overflow-y: auto;
}

.custom-tabs .v-tab{
  background-color: transparent;
}

.custom-tabs .v-tabs-slider {
  background-color: transparent !important;
}

.custom-tabs {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

.custom-tabs::-webkit-scrollbar {
  height: 8px;
}

.custom-tabs::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.custom-tabs::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  transition: background-color 0.2s;
}

.custom-tabs::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.custom-tabs .v-tabs__wrapper {
  overflow-x: auto;
  overflow-y: hidden;
}

.custom-tabs .v-tabs__container {
  flex-wrap: nowrap;
}

.tab-item {
  flex-shrink: 0;
  white-space: nowrap;
  min-width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration-general/configuration-params-globales.vue